<template>
  <div id="index">
    <!-- <mt-videolist :videotype="videotype"></mt-videolist> -->
    <!-- <mt-scoll></mt-scoll> -->
    <!-- 公告栏目 -->
    <!-- <img style="height:100vh;" :src="'http://222.77.181.149:9001'+item.files.filedownpath"> -->
    <div v-if="isSwipe ==true" style="height:100vh;">
      <el-button round size="mini" style="position:fixed;z-index:9999;top:2em;right:2em;background-color:rgba(0,0,0,0.25);color:white;border:none;" v-show="isSwipe ==true" @click="getSpwie">跳过 {{Imagenum}}</el-button>
      <mt-swipe :auto="intervalNum" :show-indicators="false">
        <mt-swipe-item v-for="(item,index) of imageData" :key='index'>
          <img style="height:100vh;" :src="httpUrl+item.files.filedownpath">
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <div v-if="isSwipe == false">
      <!-- 明厨亮灶信号源 -->
      <div class="Unit_qualiy">
        <div>
          <mt-videolist :videotype="videotype"></mt-videolist>
        </div>
      </div>
      <section class="publicity">
        <div class="publicity-box">
          <div class="publicity-title">
            餐饮服务食品安全等级公示
            <br>
            <span class='foot_size'> Food Safety Grades Notification</span>
          </div>
          <div class="publicity-dynamic">
            <dl>
              <dt>
                <img src="../../img/A.png" class="imgs" v-if="this.config_CreditLevelUnid=='A'">
                <img src="../../img/B.png" class="imgs" v-if="this.config_CreditLevelUnid=='B'">
                <img src="../../img/C.png" class="imgs" v-if="this.config_CreditLevelUnid=='C'">
                <img src="../../img/D.png" class="imgs" v-if="this.config_CreditLevelUnid=='D'">
                <img src="../../img/E.png" v-if="this.config_CreditLevelUnid==''">
                <img src="../../img/E.png" v-if="this.config_CreditLevelUnid==null">
                <!-- <img src="../../img/D.png" v-if="this.InfosData.lastYearEnterpriseLevel=='整改中'">
                                    <img src="../../img/E.png" v-if="this.InfosData.lastYearEnterpriseLevel=='未评级'"> -->
              </dt>
              <dd>上年度综合等级</dd>
            </dl>
            <dl>
              <dt>
                <img src="../../img/excellent.png" v-if="this.dynamicCreditLevelUnid=='优秀'">
                <img src="../../img/good.png" v-if="this.dynamicCreditLevelUnid=='良好'">
                <img src="../../img/commonly.png" v-if="this.dynamicCreditLevelUnid=='一般'">
                <img src="../../img/E.png" v-if="this.dynamicCreditLevelUnid=='未评定'">
                <img src="../../img/E.png" v-if="this.dynamicCreditLevelUnid=='待评定'">
                <img src="../../img/E.png" v-if="this.dynamicCreditLevelUnid==''">
                <img src="../../img/E.png" v-if="this.dynamicCreditLevelUnid==null">
                <!-- <img src="../img/D.png" v-if="this.Grade=='整改中'">
                            <img src="../img/E.png" v-if="this.Grade=='未评级'"> -->
              </dt>
              <dd>本次检查动态等级</dd>
            </dl>
          </div>
          <div class="publicity-standard">
            <dl>
              <dt>
                <img src="../../img/excellent.png">
              </dt>
              <dd class="excellent">A
                <span>(优秀)</span>
              </dd>
            </dl>
            <dl>
              <dt>
                <img src="../../img/good.png">
              </dt>
              <dd class="good">B
                <span>(良好)</span>
              </dd>
            </dl>
            <dl>
              <dt>
                <img src="../../img/commonly.png">
              </dt>
              <dd class="commonly">C
                <span>(一般)</span>
              </dd>
            </dl>
          </div>
        </div>
      </section>
      <el-collapse accordion v-model="activeNames">

        <!-- 单位资质  1278显示 其余不显示  -->
        <el-collapse-item name="1">
          <template slot="title">
            <div>
              <img src="../../img/icon1.png"> 单位资质
            </div>
          </template>
          <div class="Unit_qualiy">
            <ul>
              <li class="unit_title">企业名称：
                <label>{{this.enterprise.name}}</label>
              </li>
              <li>生产地址：
                <label>{{this.enterprise.businessaddress}}</label>
              </li>
              <li>许可证号：
                <label>{{this.info.code}}</label>
              </li>
              <li>发证机关：
                <label>{{this.info.gov}}</label>
              </li>
              <li>核定经营项目：
                <label>{{this.info.beproject}}</label>
              </li>
              <li>日常监管责任机构：
                <label>{{this.enterprise && this.enterprise.configInstitution?this.enterprise.configInstitution.name:""}}</label>
              </li>
              <li>日常监管责任人员：
                <label>{{this.info.govperson}}</label>
              </li>
              <li>许可期限
                <label v-if='this.info.startdate!=null&&this.info.enddate!=null'>{{this.info.startdate|time}}至{{this.info.enddate|time}}</label>
                <label v-else>暂无</label>
              </li>
              <el-divider content-position="left" v-if="imgData.businessLicensePic">营业执照</el-divider>
              <div class="demo-image__preview" v-if="imgData.businessLicensePic">
                <el-image style="width: 100px; height: 100px" :src="httpUrl+imgData.businessLicensePic" lazy>
                </el-image>
              </div>
              <!-- :preview-src-list="srcList" 图片预览 要的话把图片放到一个数组里去-->

              <el-divider content-position="left" v-if="imgData.permitPic">许可证明</el-divider>
              <div class="demo-image__preview" v-if="imgData.permitPic">
                <el-image style="width: 100px; height: 100px" :src="httpUrl+imgData.permitPic" lazy>
                </el-image>
              </div>

            </ul>
          </div>
        </el-collapse-item>
        <!--   健康证公示 -->
        <el-collapse-item name="2">
          <template slot="title"><img src="../../img/icon2.png" /> 健康证公示</template>
          <ul class="Health_certificate" v-if='this.PersonData!=null&&this.PersonData!=""'>
            <li v-for="item of PersonData">
              <div class="Health_img" v-if="item.file!=null">
                <img :src="httpUrl+item.file.fullpath">
                <!-- <img :src="'http://192.168.1.171:60977/'+ item.serverFullPath"> -->
              </div>
              <div class="Health_content">
                <p>
                  姓名：{{item.name}} 性别：{{item.sex ==1?'男':'女'}}
                  <span class="healthstauc">体检情况：{{item.health ==1?'合格':'不合格'}}</span>
                </p>
                <P>健康证号：{{item.healthcode}}</P>
                <p>发证机关：{{item.issuingauthority}}</p>
                <p>有效截止日期：{{item.enddate|time}}</p>
              </div>
            </li>
          </ul>
          <div class="none_data" v-else>
            <img src="../../img/tip.png">
          </div>
        </el-collapse-item>
        <!--  原料索证公示  -->
        <el-collapse-item name="3">
          <template slot="title"><img src="../../img/icon3.png" /> 原料索证公示</template>
          <ul class="Additive" v-if='this.rawMaterialData!=0'>
            <li v-for='item of rawMaterialData'>
              <div class="Additive_content">
                <p>
                  原料类别：{{item.demandtypename}} 原料名称：{{item.demandwarehousename}}
                </p>
                <P>含净量/规格：{{item.norms}}</P>
                <p>供应商：{{item.suppliername}}</p>
                <p>进货数：{{item.num}} 验收人：{{item.enterprisepersonname}}</p>
                <p>有效日期：{{item.deadlinedate |time}}</p>
              </div>
            </li>
          </ul>
          <div class="none_data" v-else>
            <img src="../../img/tip.png">
          </div>
        </el-collapse-item>
        <el-collapse-item name="5">
          <template slot="title"><img src="../../img/icon3.png" /> 添加剂公示</template>
          <ul class="Additive" v-if='this.AdditivesData!=0'>
            <li v-for='item of AdditivesData'>
              <div class="Additive_content">
                <p>
                  企业名称：{{item.enterprise.name}}
                </p>
                <P>备案号：{{item.recordnumber}}</P>
                <p>食品安全管理员：{{item.caterpeople}}</p>
                <!-- <P>添加剂名称：{{item.name}}</P>
                <p>记录人:{{item.username}}</p> -->
                <p>备案时间：{{item.recorddate |time}}</p>
              </div>
            </li>
          </ul>
          <div class="none_data" v-else>
            <img src="../../img/tip.png">
          </div>
        </el-collapse-item>
        <!-- 食品安全相关知识  -->
        <el-collapse-item name="4">
          <template slot="title"><img src="../../img/icon4.png" /> 通知公告</template>
          <ul class="Food_Safety" v-if='this.FoodSafetyData!=0'>
            <li v-for='item of FoodSafetyData' :key='item.unid'>
              <router-link :to='{name: "Notedetail",query:{unid:item.unid}}'>
                <div class="Food_Safety_content">
                  <div class="Food_Safety_img" v-if="item.newsPicture!=null">
                    <img :src="item.newsPicture.serverFullPath">
                  </div>
                  <div class="Food_Safety_text">
                    <article>
                      {{item.title}}
                    </article>
                    <time>{{item.versionDate}}</time>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
          <div class="none_data" v-else>
            <img src="../../img/tip.png">
          </div>
        </el-collapse-item>
        <!-- 明厨亮灶  -->
        <!-- <el-collapse-item name="0">
          <template slot="title">
            <img src="../../img/icon4.png" /> 学校点评
            <div></div>
          </template>
          <div class="Unit_qualiy">
            <el-button type="primary" @click='navto'>前往点评</el-button>
          </div>
        </el-collapse-item>
        <el-collapse-item name="8">
          <template slot="title">
            <img src="../../img/icon4.png" /> {{ baseName }}
            <div></div>
          </template>
          <div class="Unit_qualiy">
            <div>
              <div style='text-align: center;'> <img style="width: 200px; height: 200px" src="../../img/Vix.jpg" />
              </div>
            </div>
          </div>
        </el-collapse-item> -->
      </el-collapse>
      <mt-footer></mt-footer>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Video from "@/components/videolist";
import Footer from "@/components/footer";
import moment from "moment";
import { Toast, Loadmore, Field, Popup } from "mint-ui";
import {
  ConsumerTipsData,
  entAppAdvertisement,
  AnnexGetData,
  DemandCertificateData,
  foodAdditivesgetPageData,
  EnterprisePersonData,
  SingleEnterpriseCheckNumber,
  SingleEnterprise,
  GetToken,
  requestLogin,
  EvaluationScoring,
  GetEnterpriseScoreTop10,
  GetGuid,
  GetVideoUrl,
  SubjectCreditRewardPunish,
  SubjectCreditExtractCheck,
  IsAuthCode,
  dataApiGetEnterprise,
} from "../../api/api";
import goBackS from "@/page/index/goBackS";
export default {
  components: {
    "mt-videolist": Video,
    "mt-footer": Footer,
  },
  data() {
    return {
      isGg: false,
      baseName: window.IPConfig.baseName,
      isSwipe: false,
      isOver: false,
      // IsEnter: true,
      httpUrl: "",
      IsEnter: false,
      optionsa: [
        {
          value: "1",
          label: "行政处罚",
        },
        {
          value: "2",
          label: "移送司法机关处理记录",
        },
        {
          value: "3",
          label: "政府部门、行业协会对企业的表彰奖励、典型示范、行业推荐",
        },
      ],
      status: [
        {
          value: 1,
          label: "合格",
        },
        {
          value: 2,
          label: "不合格",
        },
      ],
      sex: [
        {
          value: "1",
          label: "男",
        },
        {
          value: "2",
          label: "女",
        },
      ],
      Imagenum: 0,
      intervalNum: 1000,
      imageSize: 0,
      CurrentAllScore: 0,
      listData: {
        LicensingScore: "",
        MessageScore: "",
        InstitutionalBuildingScore: "",
        PersonalManagementScore: "",
        EnvironmentalHealthScore: "",
        MaterialManagementScore: "",
        QualityControlScore: "",
        OtherIdea: "",
      },
      rules: {
        LicensingScore: [
          {
            required: true,
            message: "请评分",
            trigger: "blur",
          },
        ],
        MessageScore: [
          {
            required: true,
            message: "请评分",
            trigger: "blur",
          },
        ],
        InstitutionalBuildingScore: [
          {
            required: true,
            message: "请评分",
            trigger: "blur",
          },
        ],

        PersonalManagementScore: [
          {
            required: true,
            message: "请评分",
            trigger: "blur",
          },
        ],
        EnvironmentalHealthScore: [
          {
            required: true,
            message: "请评分",
            trigger: "blur",
          },
        ],
        MaterialManagementScore: [
          {
            required: true,
            message: "请评分",
            trigger: "blur",
          },
        ],
        QualityControlScore: [
          {
            required: true,
            message: "请评分",
            trigger: "blur",
          },
        ],
      },
      videotype: "",
      authCode: "",
      password: "",
      PageSize: 10,
      getuniddata: "",
      imgData: {},
      FoodSafetyData: [],
      videoData: [],
      EnterpriseScoreTop10: [],
      enterprise: [],
      ExtractCheck1: [],
      RewardPunish1: [],
      AdditivesData: [],
      rawMaterialData: [],
      InfosData: [],
      PersonData: [],
      CriteriaList: [],
      EntSwipeData: [],
      imageData: [],
      info: {
        code: "",
        beProject: "",
        gov: "",
        govDepartmentname: "",
        institutionPersonName: "",
        govdepartment: "",
        govperson: "",
        startdate: "",
        enddate: "",
      },
      /* */
      config_CreditLevelUnid: "",
      dynamicCreditLevelUnid: "",
      activeNames: ["1"],
      //activeNames: ['1'],
      economicType: "",
    };
  },
  beforeCreate() { },
  created() {
    this.httpUrl = window.IPConfig.baseIP;
    let self = this
    this.EntSwipe();
    this.fetchDta();

  },
  watch: {
  },
  //方法
  methods: {
    fetchDta() {
      var _this = this;
      var unid = this.$geturlpara.getUrlKey("unid");
      if (!unid) {
        unid = this.$geturlpara.getUrlKey("Unid");
      }
      sessionStorage.setItem(
        "WapEnterpriseUnid",
        JSON.stringify({
          unid: unid,
        })
      );
      this.Infos();
      this.FoodSafety();
      this.rawMaterial();
      this.EnterprisePerson();
      // this.getunid();
    },
    getunid: function () {
      //调取接口
      GetGuid().then((res) => {
        if (res.success === true) {
          this.getuniddata = res.data;
        }
      });
    },
    shows: function (item) {
      item == !item;
    },
    /*食品安全 */
    FoodSafety() {
      let varQueryData = {
        pageSize: 30,
        currentPage: 1,
        query: {
          criteriaList: this.CriteriaList,
        },
      };
      let options = {
        params: {
          queryData: JSON.stringify(varQueryData),
        },
      };
      //调取接口
      ConsumerTipsData(options).then((res) => {
        if (res.success === true) {
          this.FoodSafetyData = res.data.data;
        }
      });
    },
    /*宣传信息 */
    EntSwipe() {
      this.isOver = localStorage.getItem("IsOver");
      if (!this.isOver) {
        let varQueryData1 = {
          pageSize: 30,
          currentPage: 1,
          query: {
            criteriaList: [
              { name: "isenable =", value: 1, operate: "Like", endSuffix: "" },
              {
                name: "title like",
                value: "Web二维码",
                operate: "Like",
                endSuffix: "",
              },
            ],
          },
        };
        let options1 = {
          params: {
            queryData: JSON.stringify(varQueryData1),
          },
        };
        //调取接口
        entAppAdvertisement(options1).then((res) => {
          if (res.success === true) {
            this.EntSwipeData = res.data.data;
          }
          if (res.data.data.length > 0) {
            this.Swipeimage(res.data.data);
          } else {
            this.isSwipe = false;
          }
        });
      } else {
        var storage = window.localStorage;
        storage.clear();
      }
    },
    getSpwie() {
      this.isSwipe = false;
      clearTimeout(this.timer);
      clearTimeout(this.timer1);
    },
    getSpwie1() {
      this.Imagenum = this.Imagenum - 1;
    },
    /*宣传图 */
    Swipeimage(a) {
      this.isSwipe = false;
      this.CriteriaList1 = {
        Name: "a.mainDataUnid=",
        Value: a[0].unid,
        Operate: "Like",
        DataType: null,
        EndSuffix: "",
        Suffix: null,
      };

      let varQueryData2 = {
        pageSize: 30,
        currentPage: 1,
        query: {
          criteriaList: this.CriteriaList1,
        },
      };
      let options2 = {
        params: {
          queryData: JSON.stringify(varQueryData2),
          unid: a[0].unid,
        },
      };
      //调取接口
      AnnexGetData(options2).then((res) => {
        if (res.success === true && !this.$route.params.isG) {
          this.imageData = res.data;
          console.log(this.imageData);
          this.imageSize = this.imageData.length;
          this.Imagenum = a[0].timing; //时间秒数

          console.log(this.imageSize);
          this.intervalNum = (this.Imagenum / this.imageSize) * 1000;
          console.log(this.intervalNum);
          // this.Imagenum = 10 //时间秒数
          this.timer = setTimeout(this.getSpwie, a[0].timing * 1000); //自动消失的时间
          this.timer1 = setInterval(this.getSpwie1, 1000); //倒计时
          this.isSwipe = true;
          this.isOver = true;
        } else {
          this.isSwipe = false;
        }
      });
    },

    /*企业排行 */
    ScoreTop10() {
      let options = {
        params: {
          UserUnid: JSON.parse(sessionStorage.getItem("WapEnterpriseUnid"))
            .unid,
        },
      };
      //调取接口
      GetEnterpriseScoreTop10(options).then((res) => {
        if (res.success === true) {
          this.EnterpriseScoreTop10 = res.data.data;
        }
      });
    },

    /* 评价 */
    navto() {
      this.$router.push({
        path: "EntEvaluate",
        query: {
          name: this.enterprise.name,
          unid: this.$geturlpara.getUrlKey("unid")
            ? this.$geturlpara.getUrlKey("unid")
            : this.$geturlpara.getUrlKey("Unid"),
        },
      });
    },

    /*违法信息 */
    RewardPunish() {
      this.CriteriaList[0] = {
        Name: "enterprise.unid",
        Value:
          "%" +
          JSON.parse(sessionStorage.getItem("WapEnterpriseUnid")).unid +
          "%",
        Operate: "Like",
        DataType: null,
        EndSuffix: "",
        Suffix: null,
      };
      let varQueryData = {
        pageSize: this.PageSize,
        currentPage: 1,
        query: {
          criteriaList: this.CriteriaList,
        },
      };
      let options = {
        params: {
          queryData: JSON.stringify(varQueryData),
        },
      };
      //调取接口
      SubjectCreditRewardPunish(options).then((res) => {
        if (res.success === true) {
          this.RewardPunish1 = res.data.data;
        }
        // this.RewardPunish1.forEach(obj => {
        //   obj["isShow"]=false;
        // });
        // console.log(this.RewardPunish1);
      });
    },

    /*监督抽查 */
    ExtractCheck() {
      this.CriteriaList[0] = {
        Name: "enterprise.unid",
        Value:
          "%" +
          JSON.parse(sessionStorage.getItem("WapEnterpriseUnid")).unid +
          "%",
        Operate: "Like",
        DataType: null,
        EndSuffix: "",
        Suffix: null,
      };
      let varQueryData = {
        pageSize: this.PageSize,
        currentPage: 1,
        query: {
          criteriaList: this.CriteriaList,
        },
      };
      let options = {
        params: {
          queryData: JSON.stringify(varQueryData),
        },
      };
      //调取接口
      SubjectCreditExtractCheck(options).then((res) => {
        if (res.success === true) {
          this.ExtractCheck1 = res.data.data;
        }
      });
    },
    /*原料索证 */
    rawMaterial() {
      this.CriteriaListraw = [];

      var lraw = {
        name: "b.unid like",
        value:
          "%" +
          JSON.parse(sessionStorage.getItem("WapEnterpriseUnid")).unid +
          "%",
        operate: "Like",
        endSuffix: "",
      };
      this.CriteriaListraw.push(lraw);

      let varQueryData = {
        pageSize: 30,
        currentPage: 1,
        query: {
          criteriaList: this.CriteriaListraw,
        },
      };
      let options = {
        params: {
          queryData: JSON.stringify(varQueryData),
        },
      };
      //调取接口
      DemandCertificateData(options).then((res) => {
        if (res.success === true) {
          this.rawMaterialData = res.data.data;
        }
      });
      foodAdditivesgetPageData({
        params: {
          queryData: JSON.stringify({
            pageSize: 30,
            currentPage: 1,
            query: {
              criteriaList: [
                {
                  name: "a.enterpriseunid like",
                  value:
                    "%" +
                    JSON.parse(sessionStorage.getItem("WapEnterpriseUnid"))
                      .unid +
                    "%",
                  operate: "Like",
                  endSuffix: "",
                },
                // {
                //   name: "a.status =",
                //   value: 1,
                //   operate: "Like",
                //   endSuffix: "",
                // },
              ],
            },
          }),
        },
      }).then((res) => {
        if (res.success === true) {
          this.AdditivesData = res.data.data;
        }
      });
    },
    /*添加剂 */
    FoodAdditives() {
      let options = {
        params: {
          enterpriseUnid: JSON.parse(
            sessionStorage.getItem("WapEnterpriseUnid")
          ).unid,
          currentPage: 1,
          pageSize: 10,
        },
      };
      //调取接口
      foodAdditivesgetPageData(options).then((res) => {
        if (res.success === true) {
          this.AdditivesData = res.data.data;
        }
      });
    },
    /*健康证人员 */
    EnterprisePerson() {
      this.CriteriaList = [];

      var l = {
        name: "enterpriseunid Like",
        value:
          "%" +
          JSON.parse(sessionStorage.getItem("WapEnterpriseUnid")).unid +
          "%",
        operate: "Like",
        endSuffix: "",
      };
      this.CriteriaList.push(l);

      let varQueryData = {
        pageSize: 30,
        currentPage: 1,
        query: {
          criteriaList: this.CriteriaList,
        },
      };
      let options = {
        params: {
          queryData: JSON.stringify(varQueryData),
        },
      };
      //调取接口
      EnterprisePersonData(options).then((res) => {
        if (res.success === true) {
          this.PersonData = res.data.data;
          console.log(this.PersonData);
        }
      });
    },
    /*企业相关信息*/
    Infos() {
      let options = {
        params: {
          unid: JSON.parse(sessionStorage.getItem("WapEnterpriseUnid")).unid,
        },
      };
      //调取接口
      SingleEnterprise(options).then((res) => {
        if (res.success === true) {
          this.GetImgData();
          this.InfosData = res.data;
          this.enterprise = res.data.enterprise;
          this.economicType = this.InfosData.permit[0].economicType;
          this.config_CreditLevelUnid = this.InfosData.enterprise.configCreditlevelunid;
          this.dynamicCreditLevelUnid = this.InfosData.enterprise.dynamiccreditlevelunid;
          this.videotype = this.InfosData.transformationType;
          this.info.code = this.InfosData.permit[0].code;
          this.info.beproject = this.InfosData.permit[0].beproject;
          this.info.gov = this.InfosData.permit[0].certificateorgan;
          this.info.govdepartment = this.InfosData.permit[0].govdepartment;
          this.info.govperson = this.InfosData.permit[0].govperson;
          this.info.startdate = moment(
            this.InfosData.permit[0].startdate
          ).format("YYYY-MM-DD");
          this.info.enddate = moment(this.InfosData.permit[0].enddate).format(
            "YYYY-MM-DD"
          );
          if (res.data.permit[0].isschool == "是") {
            this.IsEnter = false;
          } else {
            this.IsEnter = true;
          }

          // if (this.info.gov) {
          //   if (this.info.gov == "1" || this.info.gov == "2" || this.info.gov == "3" || this.info.gov == "4") {
          //     this.info.gov = "市场监督管理局";
          //   }
          // }

          // this.info.govDepartmentname = this.InfosData.govDepartment == null ? "" : this.InfosData.govDepartment
          //   .name;
          // this.info.institutionPersonName = this.InfosData.institutionPersonName;
          // this.info.startDate = this.InfosData.permits[0].startDate;
          // this.info.endDate = this.InfosData.permits[0].endDate;

          sessionStorage.setItem(
            "Wapvideo",
            JSON.stringify({
              type: res.data.transformationType,
            })
          );
        }
      });
    },
    GetImgData() {
      let options = {
        params: {
          unid: JSON.parse(sessionStorage.getItem("WapEnterpriseUnid")).unid,
        },
      };
      //调取接口
      dataApiGetEnterprise(options).then((res) => {
        if (res.success === true) {
          this.imgData = res.data;
        }
      });
    },
    /*检查次数 */
    CheckNumber() {
      let options = {
        params: {
          unid: JSON.parse(sessionStorage.getItem("WapEnterpriseUnid")).unid,
        },
      };
      //调取接口
      SingleEnterpriseCheckNumber(options).then((res) => {
        if (res.success === true) {
          this.CheckNumberData = res.data;
        }
      });
    },
  },
  mounted() {

  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.timer1);
  },
};
</script>

<style lang="scss">
.healthstauc {
  color: #41c378;
  float: right;
  margin-left: 25px;
}

.Additive {
  list-style: none;
}

.Unit_qualiy {
  padding: 10px;

  ul li {
    color: #747575;
    font-size: 0.8rem;
    margin-bottom: 5px;

    label {
      margin-left: 5px;
    }
  }

  .unit_title {
    color: #494949;
    font-size: 0.95rem;
  }
}

/*****************************面板一*********************************/
.el-divider__text {
  position: absolute;
  background-color: #eef7f5;
  padding: 0 20px;
  color: #303133;
}
.Health_certificate li,
.Additive li {
  display: -webkit-flex;
  /* Safari */
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px;
  border-bottom: 1px solid rgba(204, 204, 204, 0.34);
}

.Health_img {
  width: 6rem;
  margin-right: 10px;
}

.Health_content,
.Additive_content {
  font-size: 14px;

  p {
    margin: 0px 0px 5px 0px;
    color: #747575;
  }
}

.Food_Safety {
  li {
    padding: 10px;
    border-bottom: 1px solid #dde4e2;
  }

  p {
    margin: 0 0 10px 0px;
    font-size: 0.95rem;
    color: #494949;
  }

  .Food_Safety_content {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.Food_Safety_img {
  width: 4rem;
  margin: 0px 10px 0px 0px;
}

.Food_Safety_text {
  color: #747575;
  font-size: 0.9rem;
  width: 100%;

  time {
    font-size: 0.7rem;
  }
}

.el-collapse-item__header {
  color: #fff;
  font-size: 0.95rem;
  padding: 0px 10px;
  border: none;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
  display: -webkit-box;

  img {
    width: 23px;
    vertical-align: middle;
    margin-left: 20px;
    margin-right: 10px;
  }
}

.el-collapse-item:first-child .el-collapse-item__header {
  background: -webkit-linear-gradient(#a5adf7, #7e87d1);
  background: -o-linear-gradient(#a5adf7, #7e87d1);
  background: -moz-linear-gradient(#a5adf7, #7e87d1);
  background: linear-gradient(#a5adf7, #7e87d1);
}

.el-collapse-item:nth-child(2) .el-collapse-item__header {
  background: -webkit-linear-gradient(#52b8e4, #0b87c5);
  background: -o-linear-gradient(#52b8e4, #0b87c5);
  background: -moz-linear-gradient(#52b8e4, #0b87c5);
  background: linear-gradient(#52b8e4, #0b87c5);
}

.el-collapse-item:nth-child(3) .el-collapse-item__header {
  background: -webkit-linear-gradient(#6fa0de, #597ec1);
  background: -o-linear-gradient(#6fa0de, #597ec1);
  background: -moz-linear-gradient(#6fa0de, #597ec1);
  background: linear-gradient(#6fa0de, #597ec1);
}

.el-collapse-item:nth-child(4) .el-collapse-item__header {
  background: -webkit-linear-gradient(#55d48b, #2cb165);
  background: -o-linear-gradient(#55d48b, #2cb165);
  background: -moz-linear-gradient(#55d48b, #2cb165);
  background: linear-gradient(#55d48b, #2cb165);
}

.el-collapse-item:nth-child(5) .el-collapse-item__header {
  background: -webkit-linear-gradient(#ee8ad5, #c06dab);
  background: -o-linear-gradient(#ee8ad5, #c06dab);
  background: -moz-linear-gradient(#ee8ad5, #c06dab);
  background: linear-gradient(#ee8ad5, #c06dab);
}

.el-collapse-item:nth-child(6) .el-collapse-item__header {
  background: -webkit-linear-gradient(#f8c077, #cf9d5a);
  background: -o-linear-gradient(#f8c077, #cf9d5a);
  background: -moz-linear-gradient(#f8c077, #cf9d5a);
  background: linear-gradient(#f8c077, #cf9d5a);
}

.el-collapse-item:nth-child(7) .el-collapse-item__header {
  background: -webkit-linear-gradient(#b25639, #b25639);
  background: -o-linear-gradient(#b25639, #b25639);
  background: -moz-linear-gradient(#b25639, #b25639);
  background: linear-gradient(#b25639, #b25639);
}

.el-collapse-item:nth-child(8) .el-collapse-item__header {
  background: -webkit-linear-gradient(#00ba00, #00ba00);
  background: -o-linear-gradient(#00ba00, #00ba00);
  background: -moz-linear-gradient(#00ba00, #00ba00);
  background: linear-gradient(#00ba00, #00ba00);
}

.el-collapse-item:nth-child(9) .el-collapse-item__header {
  background: -webkit-linear-gradient(#d8f5a1, #b4d17d);
  background: -o-linear-gradient(#d8f5a1, #b4d17d);
  background: -moz-linear-gradient(#d8f5a1, #b4d17d);
  background: linear-gradient(#d8f5a1, #b4d17d);
}

.el-icon-arrow-right {
  font-size: 1.5rem;
}

.el-collapse-item__wrap {
  // background: #eef7f5;
  background-color: #fff;
}

.el-collapse-item__content {
  padding-bottom: 0;
}

.el-collapse {
  margin-bottom: 55px;
}

.none_data {
  width: 35%;
  margin: 10px auto;
}

//广告高度
.mint-swipe {
  height: 100vh;
  // height: 20vh;
}

.foot_size {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// index.vue?5a433164